import { render } from "./MainSideMenuItem.vue?vue&type=template&id=4150da1e"
import script from "./MainSideMenuItem.vue?vue&type=script&lang=js"
export * from "./MainSideMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__